module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/banner/en-9cdddfbc5b1f4085ced70dfa942859ea.jpg";